import { render, staticRenderFns } from "./publicSentimentList.vue?vue&type=template&id=2c179c6e"
import script from "./publicSentimentList.vue?vue&type=script&lang=js"
export * from "./publicSentimentList.vue?vue&type=script&lang=js"
import style0 from "./publicSentimentList.vue?vue&type=style&index=0&id=2c179c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports